// pl_pms_channel_manager.ts
// Tłumaczenia dla PMS.ChannelManager.tsx

export const plPmsChannelManager = {

  title: "Channel Manager",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    syncControl:  "Kontrola synchronizacji",
    connections:  "Połączenia",
    recentSync:   "Ostatnie próby synchronizacji",
    importLinks:  "Importowane linki",
  },

  // ── Opisy ────────────────────────────────────────────────────────────────
  descriptions: {
    neutral:         "Dystrybucja OTA bez powiązania z dostawcą, import rezerwacji, ochrona inwentarza i monitoring synchronizacji.",
    pushRates:       "Wysyłaj stawki i dostępność z idempotentnych kluczy żądań.",
    providerStatus:  "Status dostawcy i widoczność błędów.",
    rateRows:        "Wiersze stawek i inwentarza przygotowane dla wybranego okresu.",
    syncHistory:     "Historia synchronizacji i błędy bezpieczne dla ponowień.",
    externalIds:     "Zewnętrzne identyfikatory kanałów powiązane z rezerwacjami PMS.",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    connection:         "Połączenie",
    connections:        "Połączenia",
    currentPushPayload: "Aktualny payload push",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    importCompleted:"Import rezerwacji zakończony.",
    importFailed:   "Import rezerwacji nieudany.",
    syncFailed:     "Synchronizacja nieudana.",
  },

} as const;

export default plPmsChannelManager;
